import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { SimpleFlightPrice } from '../SimpleFlightPrice/SimpleFlightPrice';
import Money from '../../../../Money/components/Money';
import PriceInMiles from '../../../../PriceInMiles/PriceInMiles';
import { TaxesTooltip } from '@entities/fare/ui';
import { CdnIcon } from '@shared/ui';
export const SelectedFlightPrice = ({ fareFamily, selectedFare, passengerFares, canceled, onClear, hideOnlyPrice, subsidized, isOrderLoading, flightMessages = [] }) => {
    const { t } = useTranslation('DesktopFlightInfo');
    const { FlightPriceStyles: css } = useTheme('DesktopFlightRoute');
    const priceInMiles = useMemo(() => {
        var _a, _b;
        if ((_b = (_a = selectedFare.prices) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.priceInMiles) {
            return selectedFare.prices[0].priceInMiles;
        }
        return null;
    }, [selectedFare]);
    return (React.createElement(SimpleFlightPrice, { singleFlight: false, best: false, selected: true, flightMessages: flightMessages, subsidized: subsidized, originalPriceOrLabel: fareFamily && React.createElement("div", { className: css.fare_family }, fareFamily.title), additionalTaxes: priceInMiles && (React.createElement("div", { className: css.miles__taxes },
            t('taxes and fees'),
            ": ",
            React.createElement(Money, { money: selectedFare.prices[0].price }))), price: !hideOnlyPrice && (React.createElement(React.Fragment, null, !canceled ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: cn(css.prices__wrp) },
                !priceInMiles ? (React.createElement(Money, { moneyClassName: css.price__money, money: selectedFare.prices[0].price, isLoading: isOrderLoading })) : (React.createElement(PriceInMiles, { amount: priceInMiles, moneyClassName: cn(css.price__money, css.price_miles), currencyClassName: css.currency })),
                !!(passengerFares === null || passengerFares === void 0 ? void 0 : passengerFares.length) && (
                // see the current calculation of passengerFares in packages/core/src/Results/hooks.ts
                React.createElement(TaxesTooltip, { taxesDetails: {
                        passengerFares,
                        totalPrice: selectedFare.prices[0].price
                    } }))),
            onClear && (React.createElement("div", { className: css.clear, onClick: onClear },
                React.createElement(CdnIcon, { icon: "Action/Close-Clear" }))))) : (React.createElement("div", { className: css.canceled }, t('Canceled'))))) }));
};
